import { render, staticRenderFns } from "./add_office.vue?vue&type=template&id=045628a2&"
import script from "./add_office.vue?vue&type=script&lang=js&"
export * from "./add_office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports